"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./TickerBase.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Marquee = /*#__PURE__*/function (_Component) {
  function Marquee(props) {
    var _this;
    _classCallCheck(this, Marquee);
    _this = _callSuper(this, Marquee, [props]);
    _defineProperty(_this, "calculateWidth", function () {
      if (_this.marqueeRef.current && _this.containerRef.current) {
        var containerRect = _this.containerRef.current.getBoundingClientRect();
        var marqueeRect = _this.marqueeRef.current.getBoundingClientRect();
        var containerWidth = containerRect.width;
        var marqueeWidth = marqueeRect.width;
        if (_this.props.autoFill && containerWidth && marqueeWidth) {
          _this.setState({
            multiplier: marqueeWidth < containerWidth ? Math.ceil(containerWidth / marqueeWidth) : 1
          });
        } else {
          _this.setState({
            multiplier: 1
          });
        }
        _this.setState({
          containerWidth: containerWidth,
          marqueeWidth: marqueeWidth
        });
      }
    });
    _defineProperty(_this, "windowResizeObserver", function () {
      if (_this.resizeObserver) return;
      if (_this.marqueeRef.current && _this.containerRef.current) {
        _this.resizeObserver = new ResizeObserver(function () {
          return _this.calculateWidth();
        });
        _this.resizeObserver.observe(_this.containerRef.current);
        _this.resizeObserver.observe(_this.marqueeRef.current);
      }
    });
    _defineProperty(_this, "renderChildren", function () {
      return _react["default"].Children.map(_this.props.children, function (child) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "child"
        }, child);
      });
    });
    _defineProperty(_this, "multiplyChildren", function (multiplier) {
      return _toConsumableArray(Array(Number.isFinite(multiplier) && multiplier >= 0 ? multiplier : 0)).map(function (_, i) {
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
          key: i
        }, _react["default"].Children.map(_this.props.children, function (child) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            className: "child"
          }, child);
        }));
      });
    });
    _this.state = {
      containerWidth: 0,
      marqueeWidth: 0,
      multiplier: 1,
      isMounted: false
    };
    _this.containerRef = /*#__PURE__*/_react["default"].createRef();
    _this.marqueeRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }
  _inherits(Marquee, _Component);
  return _createClass(Marquee, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isMounted: true
      });
      this.calculateWidth();
      this.windowResizeObserver();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.children !== this.props.children) {
        this.calculateWidth();
        this.windowResizeObserver();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        multiplier = _this$state.multiplier,
        isMounted = _this$state.isMounted;
      if (!isMounted) {
        return null;
      }
      var _this$props = this.props,
        _this$props$className = _this$props.className,
        className = _this$props$className === void 0 ? '' : _this$props$className,
        _this$props$direction = _this$props.direction,
        direction = _this$props$direction === void 0 ? 'left' : _this$props$direction,
        _this$props$delay = _this$props.delay,
        delay = _this$props$delay === void 0 ? 0 : _this$props$delay,
        _this$props$duration = _this$props.duration,
        duration = _this$props$duration === void 0 ? 80 : _this$props$duration;
      var marqueeStyle = {
        '--direction': direction === 'left' ? 'normal' : 'reverse',
        '--duration': "".concat(duration, "s"),
        '--delay': "".concat(delay, "s")
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.containerRef,
        className: 'marquee-container ' + className
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "marquee",
        style: marqueeStyle
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "initial-child-container",
        ref: this.marqueeRef
      }, this.renderChildren()), this.multiplyChildren(multiplier - 1)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "marquee",
        style: marqueeStyle
      }, this.multiplyChildren(multiplier)));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = Marquee;